import notificationAlert from '@/utils/NotificationAlert'

export default {
  data() {
    return {
      pdfVisible: false,
      pdfLoading: false,
      pdfSrc: '',
      afterPdfCloseRoute: null,
      pdfPreviewCache: {},
      pdfPreviewPromise: null,
      pdfPreviewPromiseKey: null,
      resetAfterPdfClose: false
    }
  },
  methods: {
    async previewSavedPdf(id, afterCloseRoute = null, useInvoicePdf = false) {
      const previewKey = `${useInvoicePdf ? 'invoice' : 'pre-invoice'}:${id}`
      this.afterPdfCloseRoute = afterCloseRoute
      this.pdfVisible = true

      if (this.pdfPreviewCache[previewKey]) {
        this.pdfSrc = this.pdfPreviewCache[previewKey]
        this.pdfLoading = false
        return
      }

      this.pdfLoading = true
      this.pdfSrc = ''
      try {
        if (!this.pdfPreviewPromise || this.pdfPreviewPromiseKey !== previewKey) {
          this.pdfPreviewPromiseKey = previewKey
          this.pdfPreviewPromise = useInvoicePdf ? this.previewInvoicePdf(id) : this.previewPdf(id)
        }
        const response = await this.pdfPreviewPromise
        this.pdfPreviewCache[previewKey] = response.data.url
        this.pdfSrc = response.data.url
      } catch (error) {
        this.pdfVisible = false
        notificationAlert(error)
      } finally {
        if (this.pdfPreviewPromiseKey === previewKey) {
          this.pdfPreviewPromise = null
          this.pdfPreviewPromiseKey = null
        }
        this.pdfLoading = false
      }
    },
    closePdf() {
      this.pdfVisible = false
      this.pdfSrc = ''
      const route = this.afterPdfCloseRoute
      const shouldReset = this.resetAfterPdfClose
      this.afterPdfCloseRoute = null
      this.resetAfterPdfClose = false
      if (shouldReset) {
        this.resetForm()
      }
      if (route) {
        this.$router.push(route)
      }
    }
  }
}
